// src/config/captcha.js
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

import config from './constants';

const firebaseConfig = config.firebaseConfig;

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

let recaptchaVerifier = null;
let authInstance = null;

// Función principal — reuses existing verifier to avoid Google rate limits
export default function initCaptcha(reset = false) {
    if (!authInstance) {
        authInstance = firebase.auth();
    }

    // Reuse existing verifier when possible — recreating triggers Google rate limits
    if (!reset && recaptchaVerifier) {
        return { auth: authInstance, recaptcha: recaptchaVerifier };
    }

    // Only destroy old verifier when explicitly resetting (e.g. after an error)
    if (recaptchaVerifier) {
        try {
            recaptchaVerifier.clear();
        } catch (error) {
            console.log('Error clearing old recaptcha:', error);
        }
        recaptchaVerifier = null;
    }

    // Remove-and-recreate the container element on every (re)init.
    // Firebase's verifier.clear() does not reliably reset Google's internal
    // grecaptcha widget registry, so creating a new verifier against the same
    // DOM node throws "reCAPTCHA has already been rendered in this element".
    // A fresh element guarantees a clean slate.
    const oldContainer = document.getElementById('recaptcha-container');
    if (oldContainer && oldContainer.parentNode) {
        oldContainer.parentNode.removeChild(oldContainer);
    }
    const container = document.createElement('div');
    container.id = 'recaptcha-container';
    container.style.display = 'none';
    document.body.appendChild(container);

    // Create new RecaptchaVerifier
    recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
        size: 'invisible',
        callback: (response) => {
            console.log('Recaptcha resuelto', response);
        },
        'expired-callback': () => {
            console.log('Recaptcha expirado — will reset on next attempt');
            // Mark as needing reset on next use
            recaptchaVerifier._expired = true;
        }
    });

    return { auth: authInstance, recaptcha: recaptchaVerifier };
}

export function getCaptchaInstance() {
    return recaptchaVerifier;
}

export function clearCaptcha() {
    // Called on logout — destroy verifier so a fresh one is created for the next session
    if (recaptchaVerifier) {
        try {
            recaptchaVerifier.clear();
        } catch (error) {
            console.log('Error clearing recaptcha:', error);
        }
        recaptchaVerifier = null;
    }
}